import { connect } from 'react-redux';

// action creators
import { drawerClose } from '../../../../actions/drawerActions';
import { push } from 'react-router-redux';

// components
import ListItem from './ListItem';

// helpers
import getPathWithSearch from '../../../../helpers/getPathWithSearch';

const mapDispatchToProps = dispatch => ({
  navigateToPNM: (id, queryParams = {}) => {
    dispatch(drawerClose());
    dispatch(push(getPathWithSearch(`/pnm/${id}`, queryParams)));
  },
  navigateToUser: (id, queryParams = {}) => {
    dispatch(drawerClose());
    dispatch(push(getPathWithSearch(`/match/user/${id}`, queryParams)));
  },
  navigateToBumpGroup: (id, queryParams = {}) => {
    dispatch(drawerClose());
    dispatch(push(getPathWithSearch(`/match/bumpgroup/${id}`, queryParams)));
  },
});

export default connect(null, mapDispatchToProps)(ListItem);
